import type { AuditedEntityDto, EntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';
import type { OrderStatus } from '../enums/order-status.enum';
import type { StockStatus } from './stock-status.enum';

export interface CreateOrderDto {
  sommelierId: number;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  shippingAddressLine: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  notes?: string;
  paymentMethod?: string;
  paymentTransactionId?: string;
}

export interface CreateOrderItemDto {
  wineId: number;
  wineName?: string;
  quantity: number;
  unitPrice: number;
  externalCode?: string;
}

export interface CreateOrderResponseDto {
  hasStockIssues: boolean;
  noStockInAnyDeposit?: boolean;
  stockIssues: StockValidationResultDto[];
  order: OrderDto;
}

export interface CreateOrderWithItemsDto {
  sommelierId: number;
  userId?: string;
  shippingAddressLine: string;
  pickupAddress?: string;
  notes?: string;
  paymentMethod?: string;
  deliveryMethod?: string;
  priceListId?: number;
  priceListName?: string;
  couponCode?: string;
  paywayToken?: string;
  paywayInstallments?: number;
  orderItems: CreateOrderItemDto[];
  forceCreate?: boolean;
  existingOrderId?: number;
}

export interface GetOrderDto extends PagedAndSortedResultRequestDto {
  keyword?: string;
  orderStatus?: OrderStatus;
  fromCreationTime?: string;
  toCreationTime?: string;
}

export interface GetSommelierClientOrdersDto extends PagedAndSortedResultRequestDto {
  clientId?: string;
}

export interface OrderDto extends AuditedEntityDto<number> {
  sommelierId?: number;
  sommelierName?: string;
  paidAt?: string;
  shippedAt?: string;
  deliveredAt?: string;
  userName?: string;
  userSurname?: string;
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  customerDni?: string;
  customerAddress?: string;
  customerProvince?: string;
  shippingAddressLine?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  orderStatus?: OrderStatus;
  orderItems: OrderItemDto[];
  itemCount: number;
  subTotal: number;
  discount: number;
  tax: number;
  interestCharge: number;
  total: number;
  couponCode?: string;
  couponDiscountAmount?: number;
  paymentMethod?: string;
  paymentTransactionId?: string;
  deliveryMethod?: string;
  pickupAddress?: string;
  notes?: string;
  colppyRemitoNumber?: string;
  deliveredByUserId?: string;
  deliveredByUserName?: string;
  deliveryCode?: string;
  priceListName?: string;
}

export interface OrderItemDto extends EntityDto<number> {
  wineId?: number;
  wineName?: string;
  imagePath?: string;
  quantity?: number;
  unitPrice?: number;
  totalPrice?: number;
}

export interface StockValidationResultDto {
  externalCode?: string;
  wineName?: string;
  wineId?: number;
  requestedQuantity?: number;
  availableQuantity?: number;
  status?: StockStatus;
}

export interface UpdateOrderDto {
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  shippingAddressLine?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  notes?: string;
}

export interface UpdateOrderItemDto {
  id?: number;
  wineId: number;
  quantity: number;
  unitPrice: number;
}

export interface UpdateOrderWithItemsDto {
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  shippingAddressLine?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  notes?: string;
  paymentMethod?: string;
  paymentTransactionId?: string;
  orderItems?: UpdateOrderItemDto[];
}
